interface BlockItem<T = any> {
    promise: Promise<T>;
    resolve: (value: T) => void;
}
// h5ObtainProfile 常规使用的 key，没有列举全部。
interface Profile {
    device: {
        version: string;
        versionCode: number;
        did: string;
        os: string;
        lang: string;
        language: string;
    };
    user: {
        avatar: string;
        country: string;
        gendar: number;
        name: string;
        uid: string;
        userId: string;
    }
}

// h5ObtainAccessToken 类型。
interface AccessToken {
    access_token: string
}


// 对 JSBridge API 的管道操作类
export class JSBridgePipeline<T = any> {
    private queue: BlockItem<T>[] = [];
    constructor(private caller: string){}
    async fnExecuteTask() {
        let result: T | undefined;
        const task = Promise.withResolvers<T>();
        // 新任务执行前获取队尾任务，进行阻塞排队。
        const lastTask = this.queue.at(-1);
        // 当前任务先入队再执行 头部 task 任务。
        this.queue.push(task);
        if(lastTask) result = await lastTask.promise;
        return {result, task};
    }
    // 释放管道中排队的 task
    fnResolveTask(value: T, task: BlockItem<T>) {
        task.resolve(value);
        this.queue.shift();
    }
}


export type {BlockItem, Profile, AccessToken};